import axios from "axios";
import React, {useEffect, useState} from "react";
import Swal from 'sweetalert2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
function EqpNewProduct() {
    const [subcats, setSubcats] = useState([]);
    const [assetData, setAssetData] = useState({
        hsn: '',
        product: '',
        subcat: '',
        brand: '',
        model_no: '',
        serial_no: '',
        unit: '',
        pack: '',
        qty: '',
        totqty: '',
        pprice: '',
        mrp: '',
        disc: '',
        sgst: '',
        cgst: '',
        gstamount: '',
        netamount: '',
        uamount: '',
        purchase_date: '',
        warranty_start: '',
        warranty_end: '',
        amc_type: '',
        amc_vendor: '',
        amc_start: '',
        amc_end: '',
        useful_life_years: '',
        residual_value: '',
        annual_depreciation: '',
        current_asset_value: '',
        depreciation_method: 'SLM',
    });
    useEffect(() => {
        axios.get(`${baseUrl}eqp-subcat/`)
            .then(response => setSubcats(response.data))
            .catch(error => console.log(error));
    }, []);
    useEffect(() => {
        calculateAmounts();
    }, [
        assetData.qty,
        assetData.pack,
        assetData.pprice,
        assetData.disc,
        assetData.sgst,
        assetData.cgst,
        assetData.useful_life_years,
        assetData.residual_value
    ]);
    const handleChange = (e) => {
        const {name, value} = e.target;
        setAssetData(prev => ({
            ...prev,
            [name]: value
        }));
    };
    const handleDateChange = (name, date) => {
        setAssetData(prev => ({
            ...prev,
            [name]: date
        }));
    };
    const calculateAmounts = () => {
        const qty = parseFloat(assetData.qty || 0);
        const pack = parseFloat(assetData.pack || 0);
        const pprice = parseFloat(assetData.pprice || 0);
        const disc = parseFloat(assetData.disc || 0);
        const sgst = parseFloat(assetData.sgst || 0);
        const cgst = parseFloat(assetData.cgst || 0);
        const residual = parseFloat(assetData.residual_value || 0);
        const years = parseFloat(assetData.useful_life_years || 1);
        const totqty = qty * pack;
        const net = qty * pprice;
        const discAmt = (net * disc) / 100;
        const taxable = net - discAmt;
        const gstPercent = sgst + cgst;
        const gstAmt = (taxable * gstPercent) / 100;
        const finalAmount = taxable + gstAmt;
        const annualDep =
            (pprice - residual) / years;
        const currentValue =
            pprice - annualDep;
        setAssetData(prev => ({
            ...prev,
            totqty: totqty,
            gstamount: gstAmt.toFixed(2),
            netamount: finalAmount.toFixed(2),
            annual_depreciation: annualDep.toFixed(2),
            current_asset_value: currentValue.toFixed(2),
        }));
    };
    const formSubmit = async () => {
        try {
            const formData = new FormData();
            // =========================
            // CLEAN + APPEND VALUES
            // =========================
            Object.keys(assetData).forEach(key => {
                let value = assetData[key];
                // Handle Date objects
                if (value instanceof Date) {
                    value = value.toISOString().split('T')[0];
                }
                // Handle null / undefined
                if (
                    value === null ||
                    value === undefined
                ) {
                    value = '';
                }
                formData.append(key, value);
            });
            // Extra Fields
            formData.append('status', 1);
            formData.append('addedby', userName);
            formData.append('ip_add', ipAddress);
            formData.append('location', userLocation);
            // =========================
            // API CALL
            // =========================
            const response = await axios.post(
                `${baseUrl}add-equip/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            Swal.fire({
                title: 'Equipment Added Successfully',
                icon: 'success',
                timer: 2000,
                showConfirmButton: false
            });
            setTimeout(() => {
                window.location.href =
                    '/add-eqp-product/';
            }, 2000);
        } catch (error) {
            console.log(
                'FULL ERROR =>',
                error
            );
            console.log(
                'ERROR RESPONSE =>',
                error.response
            );
            console.log(
                'ERROR DATA =>',
                error.response?.data
            );
            Swal.fire({
                title: 'Save Failed',
                text: JSON.stringify(
                    error.response?.data
                ),
                icon: 'error'
            });
        }
    };
    return (
        <section className="container-fluid mt-4 mb-5">

            <div className="card shadow">

                <div
                    className="card-header text-white"
                    style={{backgroundColor: '#1bc5ce'}}
                >
                    <h4 className="mb-0">
                        Equipment Asset Creation
                    </h4>
                </div>

                <div className="card-body">

                    <div className="row">

                        <div className="col-md-3 mb-3">
                            <label>HSN Code</label>
                            <input
                                type="text"
                                className="form-control"
                                name="hsn"
                                value={assetData.hsn}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Equipment Category</label>

                            <select
                                className="form-control"
                                name="subcat"
                                value={assetData.subcat}
                                onChange={handleChange}
                            >

                                <option value="">
                                    Select Category
                                </option>

                                {subcats.map((subcat, index) => (
                                    <option
                                        key={index}
                                        value={subcat.id}
                                    >
                                        {subcat.subcat}
                                    </option>
                                ))}

                            </select>
                        </div>

                        <div className="col-md-6 mb-3">
                            <label>Equipment Name</label>

                            <input
                                type="text"
                                className="form-control"
                                name="product"
                                value={assetData.product}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label>Brand</label>

                            <input
                                type="text"
                                className="form-control"
                                name="brand"
                                value={assetData.brand}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label>Model No</label>

                            <input
                                type="text"
                                className="form-control"
                                name="model_no"
                                value={assetData.model_no}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-4 mb-3">
                            <label>Serial No</label>

                            <input
                                type="text"
                                className="form-control"
                                name="serial_no"
                                value={assetData.serial_no}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-2 mb-3">
                            <label>Pack</label>

                            <input
                                type="number"
                                className="form-control"
                                name="pack"
                                value={assetData.pack}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-2 mb-3">
                            <label>Qty</label>

                            <input
                                type="number"
                                className="form-control"
                                name="qty"
                                value={assetData.qty}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-2 mb-3">
                            <label>Total Qty</label>

                            <input
                                type="number"
                                className="form-control"
                                name="totqty"
                                value={assetData.totqty}
                                readOnly
                            />
                        </div>

                        <div className="col-md-2 mb-3">
                            <label>Unit</label>

                            <input
                                type="text"
                                className="form-control"
                                name="unit"
                                value={assetData.unit}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-2 mb-3">
                            <label>Purchase Price</label>

                            <input
                                type="number"
                                className="form-control"
                                name="pprice"
                                value={assetData.pprice}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-2 mb-3">
                            <label>MRP</label>

                            <input
                                type="number"
                                className="form-control"
                                name="mrp"
                                value={assetData.mrp}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Purchase Date</label>

                            <DatePicker
                                selected={assetData.purchase_date}
                                onChange={(date) =>
                                    handleDateChange(
                                        'purchase_date',
                                        date
                                    )
                                }
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Warranty Start</label>

                            <DatePicker
                                selected={assetData.warranty_start}
                                onChange={(date) =>
                                    handleDateChange(
                                        'warranty_start',
                                        date
                                    )
                                }
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Warranty End</label>

                            <DatePicker
                                selected={assetData.warranty_end}
                                onChange={(date) =>
                                    handleDateChange(
                                        'warranty_end',
                                        date
                                    )
                                }
                                className="form-control"
                                dateFormat="dd-MM-yyyy"
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>AMC Type</label>

                            <select
                                className="form-control"
                                name="amc_type"
                                value={assetData.amc_type}
                                onChange={handleChange}
                            >
                                <option value="">
                                    Select AMC
                                </option>

                                <option value="AMC">
                                    AMC
                                </option>

                                <option value="CMC">
                                    CMC
                                </option>

                                <option value="NONE">
                                    None
                                </option>

                            </select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Residual Value</label>

                            <input
                                type="number"
                                className="form-control"
                                name="residual_value"
                                value={assetData.residual_value}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Useful Life Years</label>

                            <input
                                type="number"
                                className="form-control"
                                name="useful_life_years"
                                value={assetData.useful_life_years}
                                onChange={handleChange}
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Annual Depreciation</label>

                            <input
                                type="text"
                                className="form-control"
                                value={assetData.annual_depreciation}
                                readOnly
                            />
                        </div>

                        <div className="col-md-3 mb-3">
                            <label>Current Asset Value</label>

                            <input
                                type="text"
                                className="form-control"
                                value={assetData.current_asset_value}
                                readOnly
                            />
                        </div>

                    </div>

                    <div className="text-center mt-4">

                        <button
                            type="button"
                            onClick={formSubmit}
                            className="btn btn-primary px-5"
                        >
                            Submit
                        </button>

                    </div>

                </div>

            </div>

        </section>
    );
}
export default EqpNewProduct;